export const SHUFFLE_CARDS_COUNT = new Array(45).fill(null).map((item, index) => index);

export const GAME_RULES_HELP_KEYS = new Array(37).fill(null).map((item, index) => index);
